<!-- Export icon (defaults to CSV default set in tdWbToolbarController -->
@if (!showFormatsDropDown() && breakpointChanges | async; as breakpointState) {
  <button id="td-wb-toolbar-item-export"
          tdWbIconButton
          tdWbIconButtonShape="circle"
          tdWbIconButtonSize="small"
          [tdWbIconButtonBackground]="(breakpointState.matches && autoSizeOverride ? 'clear' : tdWbIconButtonBackground)"
          (click)="export()"
          [attr.title]="'tdWb.component.toolbar.EXPORT' | tdWbTranslate"
          [attr.aria-label]="'tdWb.component.toolbar.EXPORT' | tdWbTranslate">
    <td-wb-icon size="18"
                iconId="download--small" />
  </button>
} @else {
  <td-wb-flyout-menu #flyoutMenu="tdWbFlyoutMenu">
    @for (fileFormat of fileFormats; track fileFormat) {
      <button [id]="'td-wb-toolbar-item-export-' + fileFormat"
              tdWbFlyoutMenuItem
              (click)="export(fileFormat)"
              [translate]="'tdWb.component.toolbar.fileFormats.' + fileFormat">
      </button>
    }
  </td-wb-flyout-menu>
  <button tdWbIconButton
          tdWbIconButtonShape="circle"
          tdWbIconButtonSize="small"
          id="td-wb-toolbar-item-export"
          [tdWbFlyoutMenuToggle]="flyoutMenu"
          [tdWbFlyoutMenuToggleOverlayPosition]="['center-left', 'bottom-left', 'top-left']"
          [attr.title]="'tdWb.component.toolbar.EXPORT' | tdWbTranslate"
          [attr.aria-label]="'tdWb.component.toolbar.EXPORT' | tdWbTranslate">
    <td-wb-icon size="18"
                iconId="download--small"
                [inline]="true" />
  </button>
}

